import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {UserService} from "../services";
import {User} from "../models"

@Injectable()
export class UserDataResolve implements Resolve<User> {
    constructor(private userService: UserService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        return this.userService.getById(route.params.id);
    }
}